import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-airway-bill-conditions',
    templateUrl: './airway-bill-conditions.component.html',
    styleUrls: ['./airway-bill-conditions.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AirwayBillConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
